import React, { Component } from "react";
import { withRouter } from "react-router";

import "zrender/lib/svg/svg";
import echarts from "echarts/lib/echarts";
import "echarts/lib/component/legend";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import Util from "../../util";
import { connect } from "react-redux";
import { getUserTransactionIncomeAndProductIncome } from "../../action/portfolioAction";

class LineEchart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 0,
    };
  }
  setEchart = (xData = [], data = [], xBase = [], baseData = [], formatter, buyList = [], sellList = []) => {
    if (window.isLess47) {
      var myChart = echarts.init(document.getElementById("SuperLine"));
    } else {
      var myChart = echarts.init(document.getElementById("SuperLine"), null, { renderer: "svg" });
    }
    let dataArr = [];
    myChart.clear();
    myChart.resize();
    myChart.setOption(setLineOption(xData, data, xBase, baseData, formatter, buyList, sellList));
    //默认选中最右一项弹出tooltip
    const timer = setTimeout(() => {
      clearTimeout(timer);
      if (!xBase.length && !xData.length) return;
      if ((!xBase.length && xData.length) || xData[xData.length - 1] >= xBase[xBase.length - 1]) {
        myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0, // 系列的 index
          dataIndex: data.length - 1, // 数据的 index
        });
      }
      if ((xBase.length && !xData.length) || xData[xData.length - 1] < xBase[xBase.length - 1]) {
        myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 1, // 系列的 index
          dataIndex: baseData.length - 1, // 数据的 index
        });
      }
      // document.querySelector('#tip').style.display='none'
    }, 900);

  };
  getColor = (value) => {
    if (!value && value !== 0) return;
    if (value === "--") return "#333";
    if (value >= 0) return "#F8515C";
    return "#1DA96B";
  };
  formatter = (params) => {
    if (params && params.length === 1 && params[0] && params[0].seriesName === '业绩基准') { params[1] = params[0]; params[0] = null; }
    return `<div class="PT_describe">
              <div class="PT_data">本策略 <span class='PT_describe_colon'>:</span> <span style='color:${this.getColor(params[0] && params[0].value)}'>${Util.toPercent(params[0] && params[0].value)}</span></div>
              <div class="PT_base_data">业绩基准 <span class='PT_describe_colon'>:</span> <span style='color:${this.getColor(params[1] && params[1].value[1])}'>${Util.toPercent(params[1] && params[1].value[1])}</span></div>
              <img style=' width: .24rem; margin-left: .1rem ' src='${require("../../img/n_icon_what@2.png")}' />
            </div>`;
  };
  componentDidMount() {
    const periodType = [1, 3, 6, 12, 36];
    const linelist = this.props.lineData[periodType[this.state.tab]] ? this.props.lineData[periodType[this.state.tab]] : {};
    let { incomeDateList: xData, incomeList4Benchmark: baseData, incomeList: data, incomeDateList4Benchmark: xBase, buyList = [], sellList = [] } = linelist;

    if (!xData) {
      xData = [];
      data = [];
    }
    if (!xBase) {
      xBase = [];
      baseData = [];
    }
    this.setEchart(xData, data, xBase, baseData, this.formatter, buyList, sellList);
  }
  shouldComponentUpdate(nextProps = {}, nextState = {}) {
    const thisProps = this.props || {},
      thisState = this.state || {};
    for (const key in nextProps) {
      if (thisProps[key] !== nextProps[key]) {
        return true;
      }
    }
    for (const key in nextState) {
      if (thisState[key] !== nextState[key]) {
        return true;
      }
    }

    return false;
  }
  componentDidUpdate() {
    const periodType = [1, 3, 6, 12, 36];
    const linelist = this.props.lineData[periodType[this.state.tab]] ? this.props.lineData[periodType[this.state.tab]] : {};
    let { incomeDateList: xData, incomeList4Benchmark: baseData, incomeList: data, incomeDateList4Benchmark: xBase, buyList = [], sellList = [] } = linelist;
    if (!xData) {
      xData = [];
      data = [];
    }
    if (!xBase) {
      xBase = [];
      baseData = [];
    }
    this.setEchart(xData, data, xBase, baseData, this.formatter, buyList, sellList);
  }
  changeTab = (index) => {
    const periodType = [1, 3, 6, 12, 36];
    let { dispatch, location, lineData } = this.props;
    if (index == this.state.tab) return;
    this.setState({ tab: index });
    if (periodType[index] in lineData) return;
    const params = {
      superFundCode: location.state.superFundCode,
      periodType: periodType[index],
    };
    dispatch(getUserTransactionIncomeAndProductIncome(params));
  };
  componentWillUnmount() {}
  render() {
    const btn = ["近1月", "近3月", "近6月", "近1年", "近3年"];
    const periodType = [1, 3, 6, 12, 36];
    const linelist = this.props.lineData[periodType[this.state.tab]] ? this.props.lineData[periodType[this.state.tab]] : {};
    let { incomeDateList: xData, incomeList4Benchmark: baseData, incomeList: data, incomeDateList4Benchmark: xBase } = linelist;

    if (!xData) {
      xData = [];
      data = [];
    }
    if (!xBase) {
      xBase = [];
      baseData = [];
    }
    const { lastIncome, lastBase } = this.props.lineDataLast;
    return (
      <div>
      {(xData && xData.length) || (xBase&&xBase.length) ?
       <div style={{ position: "relative" }}>
       {
         <div id="tip" style={{ display: "flex", alignItems: "center", position: "absolute", marginBottom: "0.36rem", color: "#3C3C3C", fontSize: ".24rem", lineHeight: ".34rem" }}>
           <div style={{ display: "flex", alignItems: "center", width: "2.5rem" }}>
             <i style={{ boxSizing: "content-box", width: ".12rem", height: ".12rem", borderRadius: "50%", border: "2px solid #ffffff", background: "#BF9B79", marginRight: ".1rem" }} />
             本策略 <span style={{ margin: "0 .1rem" }}>:</span>
             {!lastIncome && lastIncome !== 0 ? <span style={{ color: "#333" }}>--</span> : <span style={{ color: this.getColor(lastIncome) }}>{Util.toPercent(lastIncome)}</span>}
           </div>
           <div style={{ display: "flex", alignItems: "center",minWidth:'2.2rem' }}>
             <i style={{ boxSizing: "content-box", width: ".12rem", height: ".12rem", borderRadius: "50%", border: "2px solid #ffffff", background: "#CAD6E8", marginRight: ".1rem" }} />
             业绩基准 <span style={{ margin: "0 .1rem" }}>:</span>
             {!lastBase && lastBase !== 0 ? <span style={{ color: "#333" }}>--</span> : <span style={{ color: this.getColor(lastBase) }}>{Util.toPercent(lastBase)}</span>}
           </div>
           <img style={{ width: ".24rem", marginLeft: ".1rem" }} src={require("../../img/n_icon_what@2.png")} />
         </div>
       }
       <div id="SuperLine" style={{ width: "100%", height: 360, overflow: "hidden" }} />
       <div className="style_flex_row_center style_flex_average style_sm_font  target_btn">
         {btn.map((item, index) => {
           return (
             <div onClick={() => this.changeTab(index)} key={index} className={this.state.tab == index && "Tab_Selected"}>
               {item}
             </div>
           );
         })}
       </div>
     </div>
      :
      <div style={{display:"flex",flexDirection: "column", alignItems: "center", justifyContent: "center", marginTop: ".2rem"}}>
          <div id="SuperLine"/>
          <img style={{width:"4.17rem",height:"2.52rem"}} src={require("../../imgs/iconkongkongruye.png")}/>
          <text style={{fontSize:".28rem",lineHeight:".4rem"}}>这里空空如也～</text>
       </div>}
      </div>

    );
  }
}
function mapStateToProps(state, ownProps) {
  return {
    lineData: state.lineData,
    lineDataLast: state.lineDataLast,
  };
}
export default withRouter(connect(mapStateToProps)(LineEchart));

function setLineOption(xData = [], data = [], xBase = [], baseData = [], formatter, buyList = [], sellList = []) {
  let xDataN = [...new Set([...xData, ...xBase])].sort();
  // xDataN=['2022-07-01','2022-07-03','2022-07-04','2022-07-05','2022-07-06','2022-07-07','2022-07-08','2022-07-09','2022-07-28','2022-07-29','2022-08-01','2022-08-02']
  // buyList=['2022-07-28','2022-07-29'];
  // sellList=['2022-07-28','2022-08-01'];
  const symbol = (v) => {
    return (buyList && buyList.includes(v)) || (sellList && sellList.includes(v)) ? 'circle' : 'none'
  }
  const symbolColor = (v) => {
    if (buyList && buyList.includes(v) && sellList && sellList.includes(v)) {
      return 'red'
    }
    if (buyList && buyList.includes(v)) 
    {
      return "red";
    }
    if (sellList && sellList.includes(v)) {
      return "blue";
    }
  };
  let dayIncomeSeries = xDataN.map((v, i) => {
    const index=xData.indexOf(v)
    if(index===-1){
      return {
        name: v,
        value: '--',
        symbol: 'none',
      };
    }
    return {
      name: v,
      value: data[index],
      symbol:symbol(v),
      itemStyle:{
        normal:{
          color:symbolColor(v)
        },
        emphasis:{
          scale:false
        }
      }
    } 
  });
  let baseSeries = xBase.map((v, i) => [v, baseData[i]]);
  // dayIncomeSeries = [
  //   {
  //     name: '2022-07-01',
  //     value: 0.0067,
  //     symbol: symbol('2022-07-01'),
  //     symbolSize:10,
  //     itemStyle: {
  //       normal: {
  //         color: symbolColor('2022-07-01')
  //       },
       
  //     }
  //   },
  //   {
  //     name: '2022-07-03',
  //     value: '--',
  //     symbol: 'none',
  //     symbolSize:10,
  //     // itemStyle: {
  //     //   normal: {
  //     //     color: symbolColor('2022-07-03')
  //     //   },
  //     // }
  //   },
  //   {
  //     name: '2022-07-04',
  //     value: 0.0067,
  //     symbol: symbol('2022-07-04'),
  //     itemStyle: {
  //       normal: {
  //         color: symbolColor('2022-07-04')
  //       },
  //     }
  //   },
  //   {
  //     name: '2022-07-05',
  //     value: '0.0067',
  //     symbol: symbol('2022-07-05'),
  //     itemStyle: {
  //       normal: {
  //         color: symbolColor('2022-07-05')
  //       },
  //     }
  //   },
  //   {
  //     name: '2022-07-06',
  //     value: '0.0067',
  //     symbol: symbol('2022-07-06'),
  //     itemStyle: {
  //       normal: {
  //         color: symbolColor('2022-07-06')
  //       },
  //     }
  //   },
  //   {
  //     name: '2022-07-07',
  //     value: '0.0067',
  //     symbol: symbol('2022-07-07'),
  //     itemStyle: {
  //       normal: {
  //         color: symbolColor('2022-07-07')
  //       },
  //     }
  //   },
  //   {
  //     name: '2022-07-08',
  //     value: '0.0067',
  //     symbol: symbol('2022-07-08'),
  //     itemStyle: {
  //       normal: {
  //         color: symbolColor('2022-07-08')
  //       },
  //     }
  //   },
  //   {
  //     name: '2022-07-09',
  //     value: '0.0067',
  //     symbol: symbol('2022-07-09'),
  //     itemStyle: {
  //       normal: {
  //         color: symbolColor('2022-07-09')
  //       },
  //     }
  //   },
  //   {
  //     name: '2022-07-28',
  //     value: '0.0067',
  //     symbol: symbol('2022-07-28'),
  //     itemStyle: {
  //       normal: {
  //         color: symbolColor('2022-07-28')
  //       },
  //     }
  //   },
  //   {
  //     name: '2022-07-29',
  //     value: '0.0067',
  //     symbol: symbol('2022-07-29'),
  //     itemStyle: {
  //       normal: {
  //         color: symbolColor('2022-07-29')
  //       },
  //     }
  //   },
  //   {
  //     name: '2022-08-01',
  //     value: '0.0067',
  //     symbol: symbol('2022-08-01'),
  //     itemStyle: {
  //       normal: {
  //         color: symbolColor('2022-08-01')
  //       },
  //     }
  //   },
  //   {
  //     name: '2022-08-02',
  //     value: '0.0067',
  //     symbol: symbol('2022-08-02'),
  //     itemStyle: {
  //       normal: {
  //         color: symbolColor('2022-08-02')
  //       },
  //     }
  //   },];
  // baseSeries=[['2022-07-01',0.1067],['2022-07-03',0.1067],['2022-07-05',0.0167],['2022-07-06',0.0167],['2022-07-07',0.0167],['2022-07-08',0.0167],['2022-07-09',0.0167],['2022-07-28',0.0167],['2022-07-29',0.0167],['2022-08-01',0.0167],['2022-08-02',0.0167]]
  let option;
  option = {
    color: ["#BF9B79", "#CAD6E8"],
    grid: {
      left: "0%",
      right: "3%",
      bottom: "3%",
      //top:'3%',
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        boundaryGap: false,
        // color: "#878787",
        fontSize: 0,
        fontWeight: 600,
        axisLine: {
          lineStyle: {
            width: 1,
            color: "#DFDFDF",
          },
        },
        axisTick: {
          lineStyle: {
            width: 0,
          },
        },
        axisLabel: {
          color: "#878787",
          align: "center",
          // interval: (index, value) => {
          //   if (index == 0 || index == xDataN.length - 1 || index == xDataN.length / 2 - 1 || index == (xDataN.length - 1) / 2) {
          //     return value;
          //   }
          //   return false;
          // },
          interval:0,
          formatter: (value, index) => {
            if (index == 0) return `{start|${value.split("/").join("-")}}`;
            if (index == xDataN.length - 1) return `{end|${value.split("/").join("-")}}`;
            if (index == xDataN.length / 2 - 1 || index == (xDataN.length - 1) / 2) return `{middle|${value.split("/").join("-")}}`;
           return `{h|${value.split("/").join("-")}}`;
          },
          rich: {
            start: {
              width: "200%",
              align: "left",
              fontSize:9,
              color:'#333'
            },
            end: {
              width: "0%",
              align: "right",
              fontSize:9,
            },
            middle: {
              align: "center",
              fontSize:9
            },
            h:{
              fontSize:0,
              color:'rgba(0,0,0,0)',
              width:0,
              height:0,
              // display:'none'
            }
          },
        },
        data: xDataN,
      },
    ],
    yAxis: [
      {
        type: "value",
        scale: true,
        // name:'(人)',
        axisLine: {
          lineStyle: {
            width: 0,
          },
        },
        axisTick: {
          lineStyle: {
            width: 0,
          },
        },
        axisLabel: {
          formatter: function (value, index) {
            return Util.toPercent(value);
          },
        },
        splitLine: {
          lineStyle: {
            color: "#DFDFDF",
            width: 1,
            type: "dotted",
          },
        },
      },
    ],
    animation: window.isLess47,

    tooltip: {
      show: true,
      trigger: "axis",
      alwaysShowContent: true,
      position: [0, 0],
      padding: [0, 0, 0, 0],
      transitionDuration: 0,
      triggerOn:'mousemove|click',
      axisPointer: {
        type: "line",
        lineStyle: {
          color: "#48b",
          width: 1,
          type: "dashed",
          opacity: 1,
        },
      },
      backgroundColor: "#FFF",
      extraCssText: "width:100%;",
      formatter: (params) => {
        return formatter(params);
      },
    },
    calculable: true,

    series: [
      {
        name: "本策略",
        type: "line",
        smooth: true /*线条有弧度*/,
        data: dayIncomeSeries,
        connectNulls:true,
        symbolSize:6,
        // showSymbol:false,
        itemStyle: {
          normal: {
          },
        },
        areaStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "rgba(191, 155, 121, 0.15)",
              },
              {
                offset: 1,
                color: "rgba(191, 155, 121, 0)",
              },
            ]),
            origin:'start'
          },
        },
        label: {
          //打点显示提示框
          // offset: [10, 10],
          // emphasis: {
          //   show: true,
          //   formatter: (params) => {
          //     if ((buyList&&buyList.includes(params.data.name/* params.data[0] */)) && (sellList&&sellList.includes(params.data.name/* params.data[0] */))) return "{buy|转入}{n|\n\n}{sell|转出}";
          //     if (buyList&&buyList.includes(params.data.name/* params.data[0] */)) return "{buy|转入}";
          //     if (sellList&&sellList.includes(params.data.name/* params.data[0] */)) return "{sell|转出}";

          //     return "";
          //   },
          //   rich: {
          //     buy: {
          //       backgroundColor: "#F8515C",
          //       fontSize: 12,
          //       padding: 5,
          //       color: "#333",
          //       borderRadius: 5,
          //     },
          //     sell: {
          //       backgroundColor: "#1DA96B",
          //       fontSize: 12,
          //       padding: 5,
          //       color: "#333",
          //       borderRadius: 5,
          //     },
          //     n: {
          //       lineHeight:5
          //     },
          //   },
          // },
        },
      },
      {
        name: "业绩基准",
        type: "line",
        smooth: true,
        data: baseSeries,
        // showSymbol:false,
        connectNulls:true,
        symbol:'none',
        areaStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "rgba(189, 200, 212, 0.15)",
              },
              {
                offset: 1,
                color: "rgba(189, 200, 212, 0)",
              },
            ]),
          },
        },
      },
    ],
  };

 return option;
}



// WEBPACK FOOTER //
// ./src/components/fundDetail/PerformanceTrendsHaveCastLineEcharts.js